import { Component, inject } from '@angular/core';
import { GungModalService } from '../../../../services/gung-modal/gung-modal.service';
import { Planogram } from '../../models/planogram';
import { AuthService } from '../../../../services/auth/auth.service';
import { ProductService } from '../../../../services/products/product.service';
import { first, Subject, debounceTime, distinctUntilChanged, switchMap, of, map, forkJoin } from 'rxjs';

/* /services/gung-modal/gung-modal.service'; */

@Component({
    selector: 'lib-planogram-create-config-modal',
    templateUrl: './planogram-create-config-modal.component.html',
    styleUrls: ['./planogram-create-config-modal.component.css'],
    standalone: false
})
export class PlanogramCreateConfigModalComponent {
  delegate: GungModalService;
  componentId: string;
  isEdit = false;

  additionalProducts: { id: string; qty: number }[] = [];

  planogram: Planogram = {
    id: null,
    itemNo: '',
    name: '',
    assortmentId: '',
    width: null,
    widthStep: null,
    shelfs: null,
    readOnly: false,
    items: [],
    furniture: '',
    customer: '',
    country: '',
    year: '',
    period: '',
    additionalProducts: {},
    expiredAndRemovedItems: [],
    keepModuleItems: []
  };

  disableEdit = true;
  productNames: { [id: string]: string } = {};

  protected authService = inject(AuthService);
  protected productService = inject(ProductService);

  private idInputSubject = new Subject<string>();

  ngOnInit() {
    this.componentId = PlanogramCreateConfigModalComponent.name;
    if (typeof this.planogram.additionalProducts === 'string') {
      this.planogram.additionalProducts = {};
    }
    if (this.isEdit) {
      this.authService
        .getRoles()
        .pipe(first())
        .subscribe(roles => (this.disableEdit = !roles.includes('ADMIN')));
      if (!this.planogram.additionalProducts) {
        this.planogram.additionalProducts = {};
      }
      this.getAdditionalProducts();
    } else {
      this.disableEdit = false;
    }

    this.idInputSubject
      .pipe(
        debounceTime(400),
        distinctUntilChanged(),
        switchMap(id =>
          id
            ? this.productService.getProduct(id).pipe(map(product => ({ id, product })))
            : of(null)
        )
      )
      .subscribe(result => {
        if (result) {
          this.productNames[result.id] = result.product ? result.product.name : '-';
        }
      });
  }

  onProductIdChange(id: string) {
    if (id && this.productNames[id] !== undefined) {
      return;
    }
    this.idInputSubject.next(id);
  }

  confirm() {
    this.setAdditionalProducts();
    if (this.planogram.width && this.planogram.shelfs && this.planogram) {
      this.delegate.modalRef.get(this.componentId).close(this.planogram);
    }
  }

  cancel() {
    this.delegate.modalRef.get(this.componentId).close({});
  }

  addAdditionalProduct() {
    this.additionalProducts.push({
      id: '',
      qty: 1
    });
  }

  removeAdditionalProduct(i) {
    this.additionalProducts.splice(i, 1);
  }

  setAdditionalProducts() {
    this.planogram.additionalProducts = {};
    for (const addProduct of this.additionalProducts) {
      this.planogram.additionalProducts[addProduct.id.toString()] = addProduct.qty;
    }
  }

  getAdditionalProducts() {
    const ids: string[] = [];
    for (const key in this.planogram.additionalProducts) {
      if (Object.prototype.hasOwnProperty.call(this.planogram.additionalProducts, key)) {
        const element = this.planogram.additionalProducts[key];
        this.additionalProducts.push({ id: key, qty: element });
        ids.push(key);
      }
    }
    if (ids.length > 0) {
      forkJoin(ids.map(id => this.productService.getProduct(id))).pipe(first()).subscribe(products => {
        for (const p of products) {
          this.productNames[p.id] = p.name || '-';
        }
      });
    }
  }

  removeExpired(item) {
    const index = this.planogram.expiredAndRemovedItems.indexOf(item);
    if (index !== -1) {
      this.planogram.expiredAndRemovedItems.splice(index, 1);
    }
  }

  removeKeep(item) {
    const index = this.planogram.keepModuleItems.indexOf(item);
    if (index !== -1) {
      this.planogram.keepModuleItems.splice(index, 1);
    }
  }
}
